import { Typography } from '@mui/material';
import { Box } from '@mui/material';
import  { Fragment, useState } from 'react'
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useNavigate } from 'react-router-dom';
import Axios from '../../axios/Axios';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../redux/features/appSlice';
import dayjs from 'dayjs';
function CheckLogs() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [logDates, setLogDates] = useState({
        from: null,
        to: null,
    })
    // const [validLogDates, setValidLogDates] = useState({
    //     isInvalidFromDate: false,
    //     isInvalidToDate: false,
    // })

    // form validation 
    // const groupDataValidation = (e) => {
    //     e.preventDefault();
    
    //     let canSubmitData = true;
    //     let invalidFromDate = false;
    //     // let invalidToDate = false;
    
    //     if (logDates.from === 0) {
    //         invalidFromDate = true;
    //       canSubmitData = false;
    //     }
       
    //     // if (logDates.to === 0) {
    //     //   invalidToDate = true;
    //     //   canSubmitData = false;
    //     // }
    
    //     setValidLogDates({
    //       ...validLogDates,
    //       isInvalidFromDate: invalidFromDate,
    //     //   isInvalidToDate: invalidToDate,
    //     });
    
    //     return canSubmitData;
    //   };

        // ? API Call : Post Method : Create Batch.
  async function postLogData() {
    if (logDates.from && logDates.to) {
      setLoading(true);
      const fromDate = dayjs(logDates.from).format("YYYY-MM-DD")
      const toDate =  dayjs(logDates.to).format("YYYY-MM-DD")
      console.log(fromDate, toDate, 'dates');
      
    //   setTimeout(async () => {
        try {
          setLoading(true);
          const options = {
            method: "GET",
            url: `/adminlogin/get/logs/${fromDate}/${toDate}`,
            auth: true,
            data: null,
          };

          const response = await Axios(
            options.method,
            options.url,
            options.auth,
            options.data
          );
          console.log(response);
          if (response.status === 200) {
          console.log(response);
          const url = window.URL.createObjectURL(new Blob([response.data])) 
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', "logs.csv")
          document.body.appendChild(link)
          link.click()
          link.remove()
            setLoading(false);
          } else if (response.status === 202) {
            setLoading(false);
            dispatch(
              showSnackbar({
                message: response.data,
                severity: "error",
              })
            );
          }
        } catch (error) {
          setLoading(false);
          dispatch(
            showSnackbar({
              message: "Unable to create batch. Please try again later.",
              severity: "error",
            })
          );
        }
    //   }, 1000)

    } else {
      setLoading(false);
      dispatch(
        showSnackbar({
          message:
            "Please select from and to date to view logs.",
          severity: "error",
        })
      );
    }
  }
    return (
        <Fragment>
            {/* Title */}
            <Box
                sx={{
                    mt: "16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Box>
                    <Typography variant="h5" component="div">
                        Download Logs
                    </Typography>
                </Box>
            </Box>

            {/* Input Fields */}
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    mt: "16px",
                }}
            >
                <Typography variant="p" component="div">
                    From&nbsp;Date&nbsp;<span style={{ color: "red" }}>*</span>
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <MobileDatePicker
                        sx={{ width: "30%" }}
                        label="Select from date"
                        disableFuture

                        value={logDates.from}
                        onChange={(e) => {
                            const newDate = e === null ? "" : e;
                            setLogDates(prev => ({ ...prev, from: newDate }));
                            // setValidLogDates(prev => ({ ...prev, isInvalidFromDate: false }));
                        }}
                        // slots={{
                        //     textField: (params) => <TextField
                        //         size="small"
                        //         error={validLogDates.isInvalidFromDate}
                        //         helperText={validLogDates.isInvalidFromDate && "From date is mandatory"}
                        //         {...params}
                        //     />
                        // }}
                        format="DD-MM-YYYY"
                    />
                </LocalizationProvider>
            </Box>

            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    mt: "16px",
                }}
            >
                <Typography variant="p" component="div">
                    To&nbsp;Date&nbsp;<span style={{ color: "red" }}>*</span>
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <MobileDatePicker
                        sx={{ width: "30%" }}
                        label="Select to date"
                        disableFuture

                        value={logDates.to}
                        onChange={(e) => {
                            const newDate = e === null ? "" : e;
                            setLogDates(prev => ({ ...prev, to: newDate }));
                            // setValidLogDates(prev => ({ ...prev, isInvalidFromDate: false }));
                        }}
                        // slots={{
                        //   textField: (params) => <TextField
                        //     size="small"
                        //     error={validateGroupData.isInvalidTrainingStartDate}
                        //     helperText={validateGroupData.isInvalidTrainingStartDate && "Batch created date is mandatory"}
                        //     {...params}
                        //   />
                        // }}
                        format="DD-MM-YYYY"
                    />
                </LocalizationProvider>
               
            </Box>

            {/* Buttons */}
            <Box
                sx={{
                    mt: "16px",
                    mb: "16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Button
                    type="button"
                    variant="contained"
                    color="inherit"
                    sx={{ mr: "16px" }}
                    onClick={() => navigate(-1)}
                >
                    cancel
                </Button>
                <LoadingButton
                    loading={loading}
                    type="submit"
                    variant="contained"
                    color="primary"
                    onClick={(e) => {
                        // let isValid = groupDataValidation(e);
                        // if (isValid) {
                          postLogData();
                        // } else {
                        //   dispatch(
                        //     showSnackbar({
                        //       message: "Please fill all the fields !",
                        //       severity: "error",
                        //     })
                        //   );
                        // }
                      }}
                >
                    Download Log
                </LoadingButton>
            </Box>
        </Fragment>
    )
}

export default CheckLogs